import React from 'react';
import useA2HS from '../hooks/useA2HS';
import Button from './Button';
import { Share } from 'lucide-react';
import { KiddiFitWordmark } from './Brand';

function AddToHomeTodo() {
  const { installed, canPrompt, promptInstall, isIos } = useA2HS();
  const snoozedUntil = Number(localStorage.getItem('a2hs-snoozed-until') || 0);

  // Dev override: add ?a2hs=ios or ?a2hs=android to preview on desktop
  const params = new URLSearchParams(window.location.search);
  const force = params.get('a2hs') || localStorage.getItem('a2hs-force');

  const uaMobile = /iphone|ipad|ipod|android/i.test(window.navigator.userAgent);
  let effectiveIsMobile = uaMobile;
  let effectiveIsIos = isIos;
  let effectiveInstalled = installed;
  let effectiveCanPrompt = canPrompt;

  if (force === 'ios' || force === 'android') {
    effectiveIsMobile = true;
    effectiveInstalled = false;
    effectiveIsIos = force === 'ios';
    effectiveCanPrompt = force === 'android' ? true : false;
  }

  // Only show on mobile. For Android: when prompt is available. For iOS: always until installed.
  const shouldShow =
    effectiveIsMobile &&
    !effectiveInstalled &&
    Date.now() > snoozedUntil &&
    (effectiveIsIos ? true : effectiveCanPrompt);
  if (!shouldShow) return null;

  return (
    <div className='dashboard-section'>
      <div
        className='stat-content'
        style={{ margin: 'auto', textAlign: 'center' }}
      >
        <div>
          <img
            src='logo512.png'
            alt='KiddiFit app icon'
            width={40}
            height={40}
            style={{
              borderRadius: 10,
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              marginBottom: 12,
            }}
            /* onError={(e) => {
              e.currentTarget.style.display = 'none';
            }} */
          />

          <div style={{ fontSize: 18 }}>
            Want an app experience? Add <KiddiFitWordmark /> to your Home Screen
          </div>
        </div>
        {effectiveIsIos ? (
          <div className='stat-label' style={{ marginTop: 6 }}>
            Tap the <Share size={18} /> (Share) button in Safari's toolbar, then
            select
            <strong> Add to Home Screen</strong>.
          </div>
        ) : (
          <div className='stat-label' style={{ marginTop: 6 }}>
            Install <KiddiFitWordmark /> for a faster, full-screen experience.
            <div style={{ marginTop: 12 }}>
              <Button
                type='primary'
                size='small'
                onClick={async () => {
                  const { outcome } = await promptInstall();
                  // optional: act on outcome if needed
                }}
                disabled={!effectiveCanPrompt}
              >
                Install
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AddToHomeTodo;
